/*
    Made by : Samuel
    date :
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Home from "./pages/home/Home";
import Login from "./pages/login/login";
import Admin from "./pages/admin/admin";
import NotFound from "./pages/NotFound";
import LeaderboardPage from "./pages/leaderboard/leaderboard";
import "./index.css"; // defines .light-mode / .dark-mode

// ----------------------------------------------------------------------------- //
// CONTEXT //

// eslint-disable-next-line react-refresh/only-export-components
export const ThemeContext = React.createContext<{
    isDarkMode: boolean;
    toggleTheme: () => void;
}>({ isDarkMode: false, toggleTheme: () => {} });

// ----------------------------------------------------------------------------- //
// COMPONENT //

function App() {
    // initial from localStorage or default to light
    const [isDarkMode, setIsDarkMode] = React.useState(
        () => localStorage.getItem("theme") === "dark"
    );

    const toggleTheme = () => setIsDarkMode((prev) => !prev);

    // persist preference
    useEffect(() => {
        localStorage.setItem("theme", isDarkMode ? "dark" : "light");
    }, [isDarkMode]);

    // memoize MUI theme
    const muiTheme = React.useMemo(
        () =>
            createTheme({
                palette: { mode: isDarkMode ? "dark" : "light" },
            }),
        [isDarkMode]
    );

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
            <ThemeProvider theme={muiTheme}>
                {/* CssBaseline resets & applies appropriate background/text */}
                <CssBaseline />
                <div className={isDarkMode ? "dark-mode" : "light-mode"}>
                    <Router>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/admin/*" element={<Admin />} />
                            <Route
                                path="/leaderboard/*"
                                element={<LeaderboardPage />}
                            />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Router>
                </div>
            </ThemeProvider>
        </ThemeContext.Provider>
    );
}

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default App;

// ----------------------------------------------------------------------------- //
